import { render } from "./BBPSService.vue?vue&type=template&id=571c69f5"
import script from "./BBPSService.vue?vue&type=script&lang=js"
export * from "./BBPSService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__